import { mapDataCloudfrontURL } from "../map/MapConstants";
import currentClientConfig from "../../config";
const path = `${mapDataCloudfrontURL}analytics-climate-index/${currentClientConfig.natCatGeoJsonSubDirectory}`;
export const geojsonComuni = `${path}/natcat_tiv_ver6.geojson`;
export const geojsonH6 = `${path}/natcat_tiv_hex6_ver6.geojson`;
export const geojsonH7 = `${path}/natcat_tiv_hex7_ver6.geojson`;
